import { apiFetch } from './apiClient';



/* lista de serviços do tomador; cadastro antigo (só valor/descrição) vira
   um serviço só, com o valor como unitário */
function servicosDoTomador(t) {
  if (Array.isArray(t.servicos) && t.servicos.length) {
    return t.servicos.map(s => ({ descricao: s.descricao || '', valorUnitario: s.valorUnitario ?? '', quantidade: s.quantidade ?? '', valor: s.valor ?? '', informarQuantidade: !!s.informarQuantidade }));
  }
  if (t.valor_servico == null && !t.descricao_servico) return [];
  return [{ descricao: t.descricao_servico || '', valorUnitario: t.valor_servico ?? '', quantidade: '', valor: t.valor_servico ?? '' }];
}

function fromApi(t) {
  return {
    id: t.id,
    documento: t.documento || '',
    nome: t.nome || '',
    email: t.email || '',
    telefone: t.telefone || '',
    cep: t.cep || '',
    codigoMunicipio: t.codigo_municipio || '',
    logradouro: t.logradouro || '',
    numero: t.numero || '',
    complemento: t.complemento || '',
    bairro: t.bairro || '',
    /* cobrança padrão deste tomador (opcional, editável na emissão) */
    valorServico: t.valor_servico ?? '',
    servicos: servicosDoTomador(t),
    descricaoServico: t.descricao_servico || '',
    /* fornecedor não usa "dias após a emissão": o vencimento é sempre num dia
       fixo. Cadastro antigo com dias_apos vira dia fixo no mês da nota. */
    vencimentoTipo: t.vencimento_tipo === 'dias_apos' ? 'dia_fixo_mes' : (t.vencimento_tipo || ''),
    vencimentoValor: t.vencimento_valor ?? '',
    adicionais: Array.isArray(t.adicionais) ? t.adicionais : [],
  };
}

/* autocomplete por nome/documento, dentro dos tomadores deste cliente (prestador) */
export async function buscarTomadores(clienteId, busca) {
  const data = await apiFetch(`/nf-tomadores?clienteId=${clienteId}&busca=${encodeURIComponent(busca)}`);
  return data.map(fromApi);
}

/* todos os tomadores já cadastrados para este prestador */
export async function listarTomadores(clienteId) {
  const data = await apiFetch(`/nf-tomadores?clienteId=${clienteId}&busca=`);
  return data.map(fromApi);
}

/* busca exata pelo documento -- usado ao digitar/colar o CNPJ/CPF direto */
export async function buscarTomadorPorDocumento(clienteId, documento) {
  const doc = (documento || '').replace(/\D/g, '');
  if (!doc) return null;
  const data = await apiFetch(`/nf-tomadores/documento/${clienteId}/${doc}`);
  return data ? fromApi(data) : null;
}

/* cadastra ou atualiza -- chamado depois de uma emissão real bem-sucedida */
export function salvarTomador(clienteId, dados) {
  return apiFetch('/nf-tomadores', {
    method: 'POST',
    body: JSON.stringify({
      clienteId,
      documento: dados.documento,
      nome: dados.nome,
      email: dados.email,
      telefone: dados.telefone,
      cep: dados.cep,
      codigoMunicipio: dados.codigoMunicipio,
      logradouro: dados.logradouro,
      numero: dados.numero,
      complemento: dados.complemento,
      bairro: dados.bairro,
      /* cobrança só vai quando veio do formulário do tomador -- a gravação
         automática depois da emissão não apaga o que já estava salvo */
      ...(dados.comCobranca ? {
        servicos: dados.servicos,
        vencimentoTipo: dados.vencimentoTipo, vencimentoValor: dados.vencimentoValor, adicionais: dados.adicionais,
      } : {}),
    }),
  });
}
